import React, { FC } from "react";
import { Button } from "antd";
import { TFunction } from "i18next";
import {
  CalendarPeriod,
  formatPeriodTitle,
  shiftAnchorDate,
} from "../calendarPeriod";
import { PeriodToggle } from "./PeriodToggle";

interface PeriodOption {
  value: CalendarPeriod;
  label: string;
}

interface GanttToolbarProps {
  t: TFunction;
  currentPeriod: CalendarPeriod;
  anchorDate: Date;
  periodOptions: PeriodOption[];
  onPeriodChange: (period: CalendarPeriod) => void;
  onAnchorDateChange: (date: Date) => void;
}

export const GanttToolbar: FC<GanttToolbarProps> = ({
  t,
  currentPeriod,
  anchorDate,
  periodOptions,
  onPeriodChange,
  onAnchorDateChange,
}) => (
  <div className="flex items-center gap-2 mb-3 flex-wrap">
    <div className="flex items-center gap-1">
      <Button
        onClick={() =>
          onAnchorDateChange(shiftAnchorDate(currentPeriod, anchorDate, -1))
        }
      >
        ‹
      </Button>
      <Button
        onClick={() =>
          onAnchorDateChange(shiftAnchorDate(currentPeriod, anchorDate, 1))
        }
      >
        ›
      </Button>
      <Button onClick={() => onAnchorDateChange(new Date())}>
        {t("taskHub.schedule.today") || "Today"}
      </Button>
    </div>

    <h2 className="flex-1 text-center text-lg font-semibold min-w-[200px]">
      {formatPeriodTitle(currentPeriod, anchorDate)}
    </h2>

    <PeriodToggle
      currentPeriod={currentPeriod}
      options={periodOptions}
      onChange={onPeriodChange}
    />
  </div>
);
